import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, IconButton, Icon } from "@material-ui/core";
//import Rating from "@material-ui/lab/Rating";
import { makeStyles } from "@material-ui/core/styles";
import { Base64 } from "js-base64";

import PoweredBy from "../powered-by";
import { updateHeight } from "../common";

import * as moment from "moment";
import "moment/locale/vi";
moment.locale("vi");

const useStyles = makeStyles((theme) => ({
  wrap: {
    border: "1px solid #596a7d4d",
    background: "#fff",
  },
  avatar: { maxWidth: 72, maxHeight: 72 },
  head: {
    fontSize: 13,
    fontWeight: "bold",
    marginBottom: ".25rem",
    color: "#3d5067",
  },
  body: {
    fontSize: 12,
    color: "#596a7d",
  },
  footer: {
    fontSize: 11,
    color: "#596a7d",
  },
  close: {
    position: "absolute",
    top: 0,
    right: 0,
  },
  goto: {
    cursor: "pointer",
  },
  permalink: {
    color: "initial",
    textDecoration: "none",
    display: "flex",
  },
}));

const SocialProof = () => {
  const classes = useStyles();
  const { p } = useParams();
  const param = JSON.parse(decodeURIComponent(p));

  const waitTime = param.waitTime ? param.waitTime : 5;
  const displayTime = param.displayTime ? param.displayTime : 10;
  const messageType = "social-proof";

  const [data, setData] = useState();
  const [item, setItem] = useState();
  const [index, setIndex] = useState(0);
  const [handleClose, setHandleClose] = useState(0);

  useEffect(() => {
    if (data) {
      changeItem();
    } else {
      window.addEventListener("message", (event) => {
        //console.log(event.data);
        //if (event.origin === window.origin) return;

        let data = event.data;
        if (data.type !== messageType) return;

        //console.log(data.value);
        if (data.key === "setData") {
          setItem(data.value);
        }
      });

      var url = `${
        window.location.hostname.includes("local")
          ? "https://localhost:44341"
          : "https://api.ezca.asia"
      }/api/public/SocialProof/${param.webId}`;
      fetch(url, {
        method: "GET",
      })
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          //if (!res.success) return;
          setData(res);
        });
    }
  }, [data, index]);

  const changeItem = () => {
    //console.log("changeItem");
    let hl = setTimeout(close, displayTime * 1000);
    setHandleClose(hl);

    let nextItem = data[index % data.length];
    setItem(nextItem);
    updateHeight(messageType);
    window.parent.postMessage(
      {
        type: messageType,
        key: "open",
        value: { id: param.id, item: nextItem },
      },
      "*"
    );
  };

  const close = () => {
    clearInterval(handleClose);
    //console.log("close");
    window.parent.postMessage(
      { type: messageType, key: "close", value: { id: param.id } },
      "*"
    );

    setTimeout(() => {
      setIndex(index + 1);
    }, waitTime * 1000);
  };

  const createUTMLink = (item) => {
    let paramAppend = {
      source: messageType,
      type: item.type.toLocaleLowerCase(),
    };
    const webDisabled = ["6231a3f3527397e49161665d"];
    let link = `${decodeURIComponent(item.link)}?ezca_pr=${Base64.encodeURI(
      JSON.stringify(paramAppend)
    )}`;
    link += webDisabled.includes(param.webId)
      ? ""
      : "&utm_content=ezca-social-proof";
    return link;
  };

  const goto = () => {
    let link = createUTMLink(item);
    if (item.link.includes("http://") || item.link.includes("https://"))
      window.open(link, "_parent");
    else {
      window.parent.postMessage(
        { type: messageType, key: "goto", value: { id: param.id, link } },
        "*"
      );
    }
  };

  const createDes = (des) => {
    return { __html: des };
  };
  return (
    <Box>
      {item && (
        <Box display="flex" p={2} className={classes.wrap}>
          <Box
            mr={2}
            className={classes.goto}
            onClick={() => {
              goto(item);
            }}
          >
            <img
              className={classes.avatar}
              src={
                item?.image ? item.image : "/static/images/social-proof/avt.png"
              }
              alt=""
            />
          </Box>
          <Box
            mr={2}
            className={classes.goto}
            onClick={() => {
              goto(item);
            }}
          >
            <Box className={`text-two-line ${classes.head}`} title={item.title}>
              {item.title}
            </Box>
            <Box
              className={classes.body}
              dangerouslySetInnerHTML={createDes(item.description)}
            ></Box>
            <Box className={classes.footer} mt={2}>
              {moment(item.timeStamp).fromNow()}
            </Box>
          </Box>
          <Box className={classes.close}>
            <IconButton onClick={close}>
              <Icon>close</Icon>
            </IconButton>
          </Box>
        </Box>
      )}
      <PoweredBy
        webId={param.webId}
        planId={param.planId}
        widget={messageType}
        dh={param.dh}
      />
    </Box>
  );
};
export default SocialProof;
